import { useEffect } from "react";
import { Platform, View } from "react-native";
import Animated, {
	useAnimatedStyle,
	useSharedValue,
	withDelay,
	withTiming,
} from "react-native-reanimated";
import PhotoVariant from "src/api/graphql/__generated__/enums/PhotoVariant";
import Loading from "src/components/Loading";
import VideoDurationDisplay from "src/components/VideoDurationDisplay";
import useAnimatedOpacityStyle from "src/hooks/useAnimatedOpacityStyle";
import usePhotoDetailStore from "src/screens/(internal)/PhotoDetailModal/stores/usePhotoDetailStore";
import { radiusSmall } from "src/styles/radius";

const PhotoDetailStatus = () => {
	const photo = usePhotoDetailStore((state) => state.debouncedSettledPhoto);
	const isCurPhotoLoading = usePhotoDetailStore(
		(state) => state.isWaitingForCurPhotoLoad || state.isWaitingForCurPhotoDetailedLoad,
	);
	const opacitySV = useSharedValue(0);

	useEffect(() => {
		if (!isCurPhotoLoading) {
			opacitySV.value = withDelay(200, withTiming(1, { duration: 200 }));
		}
	}, [isCurPhotoLoading, opacitySV]);

	const loadingAnimatedStyle = useAnimatedOpacityStyle(+isCurPhotoLoading);
	const durationAnimatedStyle = useAnimatedStyle(
		() => ({
			opacity: opacitySV.value,
		}),
		[opacitySV],
	);

	return (
		<View
			style={{
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "flex-end",
			}}
		>
			<Animated.View style={[{ position: "absolute" }, loadingAnimatedStyle]}>
				<Loading />
			</Animated.View>
			{/* Only Android and iOS support the custom video UI right now*/}
			{(Platform.OS === "android" || Platform.OS === "ios") &&
				photo?.variant === PhotoVariant.Video &&
				photo?.videoDuration && (
					<Animated.View style={durationAnimatedStyle}>
						<VideoDurationDisplay
							duration={photo.videoDuration}
							style={{ borderRadius: radiusSmall }}
						/>
					</Animated.View>
				)}
		</View>
	);
};
export default PhotoDetailStatus;
